import type { IWorkJourneyMatrixUser } from '@src/models/interfaces/workJourneyManagement.interface';

/**
 * Cover-only rows are users the matrix payload marks as non-members
 * (`isMember: false`). A 7-day shift has no rest filler, so membership
 * cannot be inferred from the absence of `planned` / `rest` cells.
 */
export const isMatrixCoverOnlyUser = (
  user: Pick<IWorkJourneyMatrixUser, 'isMember'> | null | undefined,
): boolean => user?.isMember === false;
